const toneStyles = {
  blue: {
    ping: "bg-blue-400 opacity-60",
    icon: "text-blue-600",
  },
  inverse: {
    ping: "bg-white opacity-50",
    icon: "text-white",
  },
};

/**
 * Leading Lucide icon with the same animate-ping ring used on section eyebrow pills.
 */
export default function PulsingPillIcon({ icon: Icon, tone = "blue" }) {
  const styles = toneStyles[tone] ?? toneStyles.blue;
  return (
    <span className="relative inline-flex h-5 w-5 shrink-0 items-center justify-center">
      <span
        className={`soft-ping absolute inline-flex h-5 w-5 rounded-full ${styles.ping}`}
        aria-hidden
      />
      <Icon className={`relative h-4 w-4 ${styles.icon}`} strokeWidth={2} aria-hidden />
    </span>
  );
}
